/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const ChevronRightSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 4.90988C5.00006 4.74682 5.03731 4.58676 5.10784 4.44646C5.17838 4.30615 5.27961 4.19073 5.40096 4.11228C5.52231 4.03383 5.65933 3.99521 5.79768 4.00047C5.93603 4.00574 6.07064 4.05468 6.18745 4.14219L9.64212 6.7317C9.75179 6.81392 9.84209 6.9274 9.90465 7.06165C9.9672 7.19589 10 7.34656 10 7.4997C10 7.65284 9.9672 7.8035 9.90465 7.93775C9.84209 8.07199 9.75179 8.18547 9.64212 8.26769L6.18745 10.8578C6.07061 10.9453 5.93595 10.9943 5.79755 10.9995C5.65915 11.0048 5.5221 10.9661 5.40074 10.8876C5.27937 10.809 5.17815 10.6935 5.10765 10.5532C5.03715 10.4128 4.99997 10.2526 5 10.0895V4.90988Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}

export default ChevronRightSvg
